export interface ContactSettings {
  id: string;
  contactNumber: string;
  whatsappNumber: string;
  address: string;
  emailAddress: string;
  accountName: string;
  accountNumber: string;
  bankName: string;
  branchName: string;
  branchCode: string;
  reference: string | null;
  footerLinksJson: string | null;
  donorTitle: string;
  donorDescriptionHtml: string;
  chairmanName: string | null;
  chairmanPhone: string | null;
  treasurerName: string | null;
  treasurerPhone: string | null;
  secretaryName: string | null;
  secretaryPhone: string | null;
  createdAt: string;
  updatedAt: string;
}

export type EditableContactSettings = Pick<
  ContactSettings,
  | 'contactNumber'
  | 'whatsappNumber'
  | 'address'
  | 'emailAddress'
  | 'accountName'
  | 'accountNumber'
  | 'bankName'
  | 'branchName'
  | 'branchCode'
  | 'reference'
  | 'footerLinksJson'
  | 'donorTitle'
  | 'donorDescriptionHtml'
>;

export const FALLBACK_CONTACT_SETTINGS: ContactSettings = {
  id: 'fallback',
  contactNumber: '073 389 8092',
  whatsappNumber: '073 389 8092',
  address: '37 Vryburger Avenue, Bothasig, Cape Town, South Africa',
  emailAddress: 'bmcsociety2000@gmail.com',
  accountName: 'Bothasig Muslim and Cultural Society',
  accountNumber: '1926 001 672',
  bankName: 'Nedbank',
  branchName: 'Century City',
  branchCode: '198765',
  reference: null,
  footerLinksJson:
    '[{"platform":"facebook","url":"https://www.facebook.com/BothasigMusallah","label":"Facebook"}]',
  donorTitle: 'Support Our Community',
  donorDescriptionHtml:
    '<p>Help us maintain and grow our masjid services for the community.</p>',
  chairmanName: null,
  chairmanPhone: null,
  treasurerName: null,
  treasurerPhone: null,
  secretaryName: null,
  secretaryPhone: null,
  createdAt: new Date(0).toISOString(),
  updatedAt: new Date(0).toISOString(),
};
